import { BadRequestException } from '../services/exceptions'
import { get } from './http'

// Get advisers meta data (company name, company number, isFavourite)
export async function getAdvisers() {
  // console.log('advisersApi.getAdvisers()')
  const response = await get(`/advisers/get/`)
  if (response.status === 200)
    return await response.json()

  throw new BadRequestException((await response.json()).message)
}
